
import { c4bApi } from '@/api/C4bApi'
import Papa from 'papaparse'
import { defineComponent, ref, onBeforeMount } from 'vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import Header from '@/components/layout/TheHeader.vue'
import TableView from '@/components/ui/TableView.vue'

export default defineComponent({
    components: {
        Header,
        TableView,
        ButtonDefault,
    },
    setup() {
        const data = ref([])

        const handleDownload = () => {
            const csv = Papa.unparse(data.value)

            const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
            const csvURL = window.URL.createObjectURL(csvData)
            var testLink = document.createElement('a')
            testLink.href = csvURL
            testLink.setAttribute('test', 'test.csv')
            testLink.click()
        }

        /** Fetching o report de usuarios */
        onBeforeMount(async () => {
            const res = await c4bApi.report().get('')
            data.value = res.data
        })
        return {
            data,
            tableColumns,
            handleDownload,
        }
    },
})

const tableColumns = [
    {
        label: 'Nome',
        field: 'name',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'E-mail',
        field: 'email',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Celular',
        field: 'cellphone',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'CNPJ',
        field: 'cnpj',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Empresa',
        field: 'company',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Crédito (R$)',
        field: 'limit',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Prazos',
        field: 'installment',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Motivo',
        field: 'reason',
        width: '3%',
        sortable: true,
        isKey: false,
    },
    {
        label: 'Status',
        field: 'status',
        width: '3%',
        sortable: true,
        isKey: false,
    },
]
